import styles from './Loader.module.css'

interface LoaderProps {
    hidden?: boolean
}

const Loader = ({ hidden }: LoaderProps) => {
    return (
        <div className={`${styles.loader}${hidden ? ` ${styles.hidden}` : ''}`}>
            <div></div>
        </div>
    )
}

export default Loader
